/* eslint-disable no-undef */
const MQ_OPTIONS          = SYSTEM_CONFIG.MQ_OPTIONS;
const KEYCLOAK_PARAMETERS = SYSTEM_CONFIG.KEYCLOAK_PARAMETERS;
const KEYCLOAK_URL_MAP    = SYSTEM_CONFIG.KEYCLOAK_URL_MAP;
const API_URL_MAP         = SYSTEM_CONFIG.API_URL_MAP;

KEYCLOAK_PARAMETERS['auth-server-url'] = KEYCLOAK_URL_MAP[window.location.host] || KEYCLOAK_URL_MAP.default || '';
const KEYCLOAK_LIBRARY                 = KEYCLOAK_PARAMETERS['auth-server-url'] + SYSTEM_CONFIG.KEYCLOAK_LIBRARY;
const API_URL                          = API_URL_MAP[window.location.host] || API_URL_MAP.default || '';

export {
  MQ_OPTIONS,
  KEYCLOAK_LIBRARY,
  KEYCLOAK_PARAMETERS,
  KEYCLOAK_URL_MAP,
  API_URL_MAP,
  API_URL,
};
